import { Header, type SharedHeaderProps } from '@lmn/contenthub-shared/components';
import { usePageWrapperData } from '@/app/common/pageWrapperProvider.tsx';
import { Brand } from '@/domainLogic/index.ts';
import ErrorBoundary from '@/app/common/components/ErrorBoundary';
import StaticHeader from '@/app/common/headerFooter/StaticHeader.tsx';
import { useMeasureHeaderHeight } from '@/app/common/headerFooter/headerHeight.ts';

const staticHeaderFallback = () => <StaticHeader />;

// Brands that get the two-row mobile header: full logo on top, collapsed CSW below (MPH-1163).
// Set here rather than per header in the CMS, where it would have to be enabled on the `ose-dp`
// header of every site.
const STACKED_MOBILE_HEADER_BRANDS: Brand[] = [Brand.BOOKING];

const ContentHubHeader = (props: SharedHeaderProps) => {
  const { localization } = usePageWrapperData();
  const { brand } = localization;
  const isLM = brand === Brand.LASTMINUTE;
  const isStackedMobileHeaderEnabled = STACKED_MOBILE_HEADER_BRANDS.includes(brand);
  useMeasureHeaderHeight();

  return (
    <ErrorBoundary id="ContentHubHeader" fallback={staticHeaderFallback}>
      {/* Only ever passed as true: an explicit false would override a header the CMS has stacked. */}
      <Header
        {...props}
        {...(!isLM && { isSmallLogoOnMobileEnabled: false })}
        {...(isStackedMobileHeaderEnabled && { isStackedMobileHeaderEnabled })}
      />
    </ErrorBoundary>
  );
};

export default ContentHubHeader;
